export const guideMixin = {
  data: () => ({
    fetchBaseUrl:
      process.env.ENVIRONMENT === "production"
        ? "https://api.service.sitevitals.net/api/v1/external"
        : "https://api.service.sitevitals-beta.com/api/v1/external",
    fetchKey:
      process.env.ENVIRONMENT === "production"
        ? "5niAV7y4J5YiYidi"
        : "28hJr4cMY8PErzNe"
  })
};



// WEBPACK FOOTER //
// ./src/components/Guide/guideMixin.js